import { useState, useCallback } from 'react';

import { useToggleModal } from '@hooks';
import {
  hasBookingCarId,
  hasBookingCustomerTypes,
  hasBookingPromisedDeliveryDates,
} from '@helpers';

export const useStateChangeRules = () => {
  const [pendingStage, setPendingStage] = useState(null);

  const {
    isOpen: isCustomerTypesModalOpen,
    handleOpen: handleCustomerTypesModalOpen,
    handleClose: handleCustomerTypesModalClose,
  } = useToggleModal();

  const {
    isOpen: isCarIdModalOpen,
    handleOpen: handleCarIdModalOpen,
    handleClose: handleCarIdModalClose,
  } = useToggleModal();

  const {
    isOpen: isPromisedDeliveryDateModalOpen,
    handleOpen: handlePromisedDeliveryDateModalOpen,
    handleClose: handlePromisedDeliveryDateModalClose,
  } = useToggleModal();

  const handleStageChangeRules = useCallback(
    (booking, vehicle, nextStage) => {
      setPendingStage(nextStage);

      if (nextStage === null || nextStage === undefined) return true;

      if (!hasBookingCustomerTypes(booking, nextStage)) {
        handleCustomerTypesModalOpen();
        return false;
      }

      if (!hasBookingCarId(booking, vehicle, nextStage)) {
        handleCarIdModalOpen();
        return false;
      }

      if (!hasBookingPromisedDeliveryDates(booking, nextStage)) {
        handlePromisedDeliveryDateModalOpen();
        return false;
      }

      return true;
    },
    [
      handleCustomerTypesModalOpen,
      handlePromisedDeliveryDateModalOpen,
      handleCarIdModalOpen,
    ]
  );

  return {
    pendingStage,
    setPendingStage,
    isCustomerTypesModalOpen,
    handleCustomerTypesModalClose,
    isCarIdModalOpen,
    handleCarIdModalClose,
    isPromisedDeliveryDateModalOpen,
    handlePromisedDeliveryDateModalClose,
    handleStageChangeRules,
  };
};
